import { loginPageInfo } from "../config"

export const URL_LEAGUE = loginPageInfo.getServerUrl() + "league/"
export const URL_UMPIRE = loginPageInfo.getServerUrl() + "umpire/"
export const URL_PARK = loginPageInfo.getServerUrl() + "park/"
export const URL_PLAYER = loginPageInfo.getServerUrl() + "player/"
export const URL_PLAYER_HISTORY = loginPageInfo.getServerUrl() + "playerHistory/"
export const URL_TEAM = loginPageInfo.getServerUrl() + "team/"
export const URL_GAME = loginPageInfo.getServerUrl() + "game/"
export const URL_CLIENT = loginPageInfo.getServerUrl() + "client/"

//League
export const URL_LEAGUE_ADD = URL_LEAGUE + 'addLeague'
export const URL_LEAGUE_EDIT = URL_LEAGUE + 'editLeague'
export const URL_LEAGUE_GET_LIST = URL_LEAGUE + 'getLeagueList'
export const URL_LEAGUE_GET_LIST_ENABLE = URL_LEAGUE + 'getLeagueListEnable'
export const URL_LEAGUE_GET_DETAIL = URL_LEAGUE + 'getLeagueDetail'
export const URL_LEAGUE_CHECK_NAME = URL_LEAGUE + 'checkLeagueName'
export const URL_LEAGUE_GAMETYPE_GET_LIST = URL_LEAGUE + 'getLeagueGameTypeList'


//Umpire
export const URL_UMPIRE_ADD = URL_UMPIRE + 'addUmpire'
export const URL_UMPIRE_EDIT = URL_UMPIRE + 'editUmpire'
export const URL_UMPIRE_GET_LIST = URL_UMPIRE + 'getUmpireList'
export const URL_UMPIRE_GET_DETAIL = URL_UMPIRE + 'getUmpireDetail'
export const URL_UMPIRE_CHECK_NAME = URL_UMPIRE + 'checkUmpireName'

//Park
export const URL_PARK_ADD = URL_PARK + 'addPark'
export const URL_PARK_EDIT = URL_PARK + 'editPark'
export const URL_PARK_GET_LIST = URL_PARK + 'getParkList'
export const URL_PARK_GET_LIST_ENABLE = URL_PARK + 'getParkListEnable'
export const URL_PARK_GET_DETAIL = URL_PARK + 'getParkDetail'
export const URL_PARK_CHECK_NAME = URL_PARK + 'checkParkName'

//Player
export const URL_PLAYER_ADD = URL_PLAYER + 'addPlayer'
export const URL_PLAYER_EDIT = URL_PLAYER + 'editPlayer'
export const URL_PLAYER_GET_LIST = URL_PLAYER + 'getPlayerList'
export const URL_PLAYER_GET_DETAIL = URL_PLAYER + 'getPlayerDetail'
export const URL_PLAYER_CHECK_NAME = URL_PLAYER + 'checkPlayerName'

export const URL_PLAYER_HISTORY_ADD = URL_PLAYER_HISTORY + 'addPlayerHistory'
export const URL_PLAYER_HISTORYList_EDIT = URL_PLAYER_HISTORY + 'editPlayerHistoryList'
export const URL_PLAYER_HISTORY_GET_LIST = URL_PLAYER_HISTORY + 'getPlayerHistoryList'
export const URL_PLAYER_LEAGUE_GET_LIST = URL_PLAYER_HISTORY + 'getPlayerLeagueList'

//Team
export const URL_TEAM_ADD = URL_TEAM + 'addTeam'
export const URL_TEAM_EDIT = URL_TEAM + 'editTeam'
export const URL_TEAM_GET_LIST = URL_TEAM + 'getTeamList'
export const URL_TEAM_GET_LIST_ARRAY = URL_TEAM + 'getTeamListArray'
export const URL_LEAGUE_TEAM_GET_LIST = URL_TEAM + 'getLeagueTeamList'
export const URL_TEAM_GET_DETAIL = URL_TEAM + 'getTeamDetail'
export const URL_TEAM_CHECK_NAME = URL_TEAM + 'checkTeamName'

//Client
export const URL_CLIENT_ADD = URL_CLIENT + 'addClient'
export const URL_CLIENT_UPDATE = URL_CLIENT + 'updateClient'
export const URL_CLIENT_GET_LIST = URL_CLIENT + 'getClientList'
export const URL_CLIENT_SET_ACTIVATION = URL_CLIENT + 'setClientActivation'
export const URL_CLIENT_SET_ACTIVATIONCODE = URL_CLIENT + 'setClientActivationCode'
export const URL_CLIENT_SET_ACTCODECAP = URL_CLIENT + 'setClientActCodeCap'

//Game
export const URL_GAME_SCORER_GET_LIST = URL_GAME + 'getScorerList'
export const URL_GAME_ADD = URL_GAME + 'addGame'
export const URL_GAME_EDIT = URL_GAME + 'editGame'
export const URL_GAME_CHECK_NO = URL_GAME + 'checkGameNo'
///取得比賽列表
export const URL_GAME_GET_LIST = URL_GAME + 'getGameList'
///取得比賽資訊
export const URL_GAME_GET_DETAIL = URL_GAME + 'getGameDetail'
///取得最新記分板數據
export const URL_GAME_GET_LAST_GAME_BOARD = URL_GAME + 'getLastGameBoard';
///取得比賽目前所有資料
export const GET_GAME_CURRENT_ALL = URL_GAME + 'getGameCurrentAll';
///取得Action List
export const GET_GAME_ACTION_LIST = URL_GAME + 'getActionList';

///取得Action List by reqaction
export const GET_ACTION_LIST_BY_REQACTION = URL_GAME + 'getActionListByReqAction';

///取得Action List by reqaction
export const GET_ACTION_LIST_BY_REQPITCH = URL_GAME + 'getActionListByReqPitch';

///取得所有球員
export const GET_ALL_PLAYERS_FROM_GAME = URL_GAME + 'getAllPlayersFromGame';

///設定 PlateRecord 裡的 action_detail
export const SET_PLATE_RECORD_ACTION_DETAIL_PITCH = URL_GAME + 'setPlateRecordActionDetailPitch';
export const SET_PLATE_RECORD_ACTION_DETAIL_BAT = URL_GAME + 'setPlateRecordActionDetailBat';

///取得須修改內容資料

export const GET_BALL_LOSS = URL_GAME + 'Get_BallsLoss'

///修改缺失資料

export const SET_BALL_LOSS = URL_GAME + 'Set_BallsLoss'